import { cva } from 'class-variance-authority';
import styles from '../../presentation/styles.module.scss';

export const closeButtonVariants = cva(styles.closeButton, {
  variants: {
    status: {
      success: styles.closeButtonSuccess,
      danger: styles.closeButtonDanger,
    },
  },
  defaultVariants: {
    status: 'success',
  },
});
